import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { Inbox, Package, Users, ArrowRight } from "lucide-react";

const Stat = ({ icon: Icon, label, value, to }) => (
  <Link
    to={to}
    className="group p-7 border border-[#E5E0D8] bg-white hover:border-[#DE9E36] transition-all"
  >
    <div className="flex items-center justify-between mb-6">
      <span className="w-10 h-10 rounded-full bg-[#F3EFE7] flex items-center justify-center text-[#DE9E36]">
        <Icon size={18} strokeWidth={1.6} />
      </span>
      <ArrowRight size={14} className="text-[#4E5750] group-hover:text-[#DE9E36] group-hover:translate-x-1 transition-all" />
    </div>
    <div className="text-4xl font-bold text-[#1A201C] tracking-tight">{value}</div>
    <div className="overline text-[#4E5750] mt-2">{label}</div>
  </Link>
);

const AdminDashboard = () => {
  const { api, user } = useAuth();
  const [stats, setStats] = useState({ contacts: 0, products: 0, users: 0, newQuotes: 0 });

  useEffect(() => {
    (async () => {
      try {
        const [c, p, u] = await Promise.all([
          api.get("/admin/contacts"),
          api.get("/admin/products"),
          api.get("/admin/users"),
        ]);
        setStats({
          contacts: c.data.length,
          newQuotes: c.data.filter((x) => x.status === "new").length,
          products: p.data.length,
          users: u.data.length,
        });
      } catch (e) {
        console.error(e);
      }
    })();
  }, [api]);

  return (
    <div className="p-6 md:p-10">
      <div className="mb-10">
        <span className="overline text-[#DE9E36]">Overview</span>
        <h1 className="mt-3 text-3xl md:text-4xl font-bold text-[#1A201C] tracking-tight">
          Welcome back, {user?.name || "Admin"}
        </h1>
        <p className="mt-2 text-sm text-[#4E5750]">
          EKOBIOTEK-UKRAINA, LLC management console.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        <Stat icon={Inbox} label="New quotations" value={stats.newQuotes} to="/admin/quotations" />
        <Stat icon={Inbox} label="Total quotations" value={stats.contacts} to="/admin/quotations" />
        <Stat icon={Package} label="Products" value={stats.products} to="/admin/products" />
        <Stat icon={Users} label="Admins" value={stats.users} to="/admin/users" />
      </div>
    </div>
  );
};

export default AdminDashboard;
